/* NYMARA LIGHTHOUSE FIXES START
   Generated by shopify_lighthouse_fixer_v2.py.
   Re-running the script replaces this whole file.
   This is only a fallback for markup that could not be patched safely in Liquid.
   Critical LCP images should still be prioritized in Liquid/HTML.
   NYMARA LIGHTHOUSE FIXES END */
(function () {
  "use strict";

  function normalizeBooleanToken(value) {
    var normalized = (value || "").toString().trim().toLowerCase();
    return normalized === "true" ? "true" : "false";
  }

  function normalizeCurrentToken(value) {
    var normalized = (value || "").toString().trim().toLowerCase();
    if (!normalized || normalized === "0" || normalized === "null" || normalized === "undefined") {
      return "false";
    }
    if (["page", "step", "location", "date", "time", "true", "false"].indexOf(normalized) !== -1) {
      return normalized;
    }
    return "true";
  }

  function hasAccessibleName(el) {
    return Boolean(
      (el.getAttribute("aria-label") || "").trim() ||
      (el.getAttribute("aria-labelledby") || "").trim() ||
      (el.textContent || "").trim()
    );
  }

  function fixStickyButtonNames() {
    var buttons = document.querySelectorAll("button.hdt-sticky-add-to-cart__button");
    buttons.forEach(function (button) {
      if (!hasAccessibleName(button)) {
        button.setAttribute("aria-label", "In den Warenkorb");
      }
    });
  }

  function sanitizeFlipButtonAria() {
    var selectedRoles = ["tab", "option", "gridcell", "row", "treeitem"];
    document.querySelectorAll("button.hdt-btn--flip-after").forEach(function (button) {
      var role = (button.getAttribute("role") || "").trim().toLowerCase();
      if (button.hasAttribute("aria-selected") && selectedRoles.indexOf(role) === -1) {
        button.removeAttribute("aria-selected");
      }
      if (button.hasAttribute("aria-current") && role !== "tab") {
        button.removeAttribute("aria-current");
      }
      if (button.hasAttribute("aria-hidden")) {
        button.removeAttribute("aria-hidden");
      }
    });
  }

  function sanitizeCircularText() {
    document.querySelectorAll("hdt-circular-text").forEach(function (el) {
      var label = (el.getAttribute("aria-label") || el.textContent || "").replace(/\s+/g, " ").trim();
      if (!label) {
        el.setAttribute("aria-hidden", "true");
        return;
      }
      if (el.classList.contains("hdt-stamp") || el.classList.contains("hdt-heading") || !el.getAttribute("role") || el.getAttribute("role") === "heading") {
        el.setAttribute("role", "img");
      }
      el.setAttribute("aria-label", label);
      ["aria-level", "aria-current", "aria-selected", "aria-expanded", "aria-pressed", "aria-controls", "aria-describedby"].forEach(function (attr) {
        el.removeAttribute(attr);
      });
      el.removeAttribute("aria-hidden");
    });
  }

  function sanitizeSliderAria() {
    document.querySelectorAll("hdt-slider-media").forEach(function (slider) {
      slider.querySelectorAll("[aria-current]").forEach(function (el) {
        el.setAttribute("aria-current", normalizeCurrentToken(el.getAttribute("aria-current")));
      });
      slider.querySelectorAll("[aria-selected]").forEach(function (el) {
        el.setAttribute("aria-selected", normalizeBooleanToken(el.getAttribute("aria-selected")));
      });
      slider.querySelectorAll("[aria-hidden]").forEach(function (el) {
        el.setAttribute("aria-hidden", normalizeBooleanToken(el.getAttribute("aria-hidden")));
      });
      slider.querySelectorAll("[aria-expanded]").forEach(function (el) {
        el.setAttribute("aria-expanded", normalizeBooleanToken(el.getAttribute("aria-expanded")));
      });
    });
  }

  function prioritizeFirstVisibleImages() {
    var selectors = [
      "body.template-index img.hdt-card-product__media--main",
      "body.template-index img.hdt-media-cover",
      "body.template-index img.hdt-object-pos-mb",
      "body.template-product img.hdt-media-cover",
      "body.template-product img.hdt-product__media",
      "body.template-product .hdt-product__media img",
      "body.template-product img"
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var selector = selectors[i];
      var img = document.querySelector(selector);
      if (!img) continue;
      if (!img.hasAttribute("fetchpriority")) img.setAttribute("fetchpriority", "high");
      if (!img.hasAttribute("loading") || img.getAttribute("loading") === "lazy") {
        img.setAttribute("loading", "eager");
      }
      break;
    }
  }

  function run() {
    fixStickyButtonNames();
    sanitizeFlipButtonAria();
    sanitizeCircularText();
    sanitizeSliderAria();
    prioritizeFirstVisibleImages();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }
}());
